import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {debounceTime, distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

// MODELOS

// SERVICIOS
import { BusinessPartnerService, PaymentService, ParamsService, AlertService, AuthenticationService, PermsService, SapService, StorageService } from '../../../services/index';
import { ICard, IPayment } from 'src/app/models';
import { IInvoicePaymentDetail } from 'src/app/models/i-invoice-payment-detail';
import {IBusinessPartnerModel} from "../../../models/i-business-partner";
import {SearchModalComponent} from "../../../components/shared/search-modal/search-modal.component";
import {ParamsSearch} from "../../../models/params";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";

// PIPES

@Component({
  selector: 'app-cancel-payments',
  templateUrl: './cancel-payments.component.html',
  styleUrls: ['./cancel-payments.component.scss']
})
export class CancelPaymentsComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  date: Date;
  nowDate: any;
  InfoInv: FormGroup;
  invList: any[] = [];
  cards: ICard[];
  StatusFact: String;
  Formadate: string;
  invoiceNumber: number;
  totalDocument: number;
  viewParamTitles: any[] = []; // llena la lista con los titulos de las paginas parametrizados
  title: string; // titulo de la vista
  currentUser: any; // variable para almacenar el usuario actual
  currentUserSubscription: Subscription; // suscripcion para obtener el usuario actual
  permisos: boolean = true;
  status: boolean[] = [true, false];
  invoiceSelected = false; //Existe factura seleccionada
  detailPaymentForm;
  globalStatus: any;
  paymentDetail: IInvoicePaymentDetail;

  titlePayment: string;
  returnedDocNumF:string;
  returnedDocNumP:string;
  page = 1;
  pageSize = 10;
  collectionSize: number;

  constructor(private fbl: FormBuilder,
    private bps: BusinessPartnerService,
    private pays: PaymentService,
    private paramsService: ParamsService,
    private alertService: AlertService,
    private sPerm: PermsService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    private modalService: NgbModal
  ) {
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
    this.date = new Date();
    this.nowDate = `${this.date.getFullYear()}-${('0' + (this.date.getMonth() + 1)).slice(-2)}-${('0' + this.date.getDate()).slice(-2)}`;
  }

  ngOnInit() {
    this.fillDetailPaymentForm();
    this.checkPermits();
    this.GetParamsViewList();
    this.InfoInv = this.fbl.group({
      Cliente: ['', Validators.required],
      FechaIni: ['', Validators.required],
      FechaFin: ['', Validators.required]
    });

    this.InfoInv.controls.FechaIni.setValue(this.nowDate);
    this.InfoInv.controls.FechaFin.setValue(this.nowDate);

  }

  fillDetailPaymentForm(): void {
    this.detailPaymentForm = new FormGroup({
      InvoiceNumber: new FormControl(''),
      PaymentNumber: new FormControl(''),
      Total: new FormControl(''),
      TotalFC: new FormControl(''),
      TotalTransfer: new FormControl(''),
      TotalTransferFC: new FormControl(''),
    });
  }
  // chequea que se tengan los permisos para acceder a la pagina de cancelacion de pagos
  checkPermits() {

    this.sPerm.getPerms(this.currentUser.userId).subscribe((data: any) => {
      this.blockUI.stop();
      if (data.result) {
        let permListtable: any = data.perms;
        data.perms.forEach(Perm => {
          if (Perm.Name === "V_Cpay") {
            this.permisos = Perm.Active;
          }
        });

      } else {
        this.permisos = false;
      }
    }, error => {
      this.permisos = false;
      this.blockUI.stop();
    });
  }

  /**
   * Searches for a business partner based on the provided text.
   *
   * @param text$ An observable that emits the search text.
   */
  searchBP = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.bps.GetBussinesPartners(value,1,10)),
      map(term => term.BusinessPartnerFilter.map(item => item.FilterField))
    )
    closeAfterPayModal(): void { }
  StatusFactura(status) {
    if (status == "O") {
      this.StatusFact = "Abierta";
    } else {
      this.StatusFact = "Cerrada";
    }
    return this.StatusFact;
  }
  // trae la lista de facturas a cancelar
  // no recive paramestros
  getInvList() {
    // if(this.InfoInv.invalid){
    //   this.alertService.infoAlert('Debe ingresar Cliente, Fecha Inicial, Fecha Final');
    //   return;
    // }
    let cardCode = '';

    if (this.InfoInv.value.Cliente.split(' ')[0]) {
      cardCode = this.InfoInv.value.Cliente.split(' ')[0];
    }

    const InfoSearch = {
      CardCode: cardCode,
      FIni: this.InfoInv.value.FechaIni,
      FFin: this.InfoInv.value.FechaFin
    };

    this.blockUI.start('Obteniendo datos de los pagos a cancelar...');
    this.pays.getInvList(InfoSearch).subscribe((data: any) => {
      if (data.result) {
        console.log(data);
        this.invList.length = 0;
        this.invList = data.paymentList;

        this.collectionSize = data.paymentList.length;
        this.invList = data.paymentList.map((so, i) => ({ id: i + 1, ...so }))
          .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);

        this.blockUI.stop(); // Stop blocking
        if (data.paymentList.length === 0) {
          this.alertService.infoAlert('No se encontraron Facturas en el rango de fechas seleccionadas');
        }
      } else {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert('Error al obtener la lista de pago - error: ' + data.errorInfo.Message);
      }
    }, (error) => {
      this.blockUI.stop(); // Stop blocking
      this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error.error.Message}`);
    });
  }


  // valida que solo un check este activo
  // parametro dacentri del modelo
  CheInv(status: any, entry: any, _docNum: number, _invoiceNumber: number, _payMent: IPayment) {
    this.blockUI.start('Obteniendo detalle de pago, espere por favor');
    this.pays.getPaymentDetail(entry).subscribe(next => {
      if (next.result) {
        this.paymentDetail = next.InvoicePaymentDetail;
        this.invoiceNumber = _invoiceNumber;
        this.fillDetailPaymentForm();
        this.detailPaymentForm.patchValue({
          InvoiceNumber: _invoiceNumber,
          PaymentNumber: _payMent.DocNumPago,
          Total: next.InvoicePaymentDetail.CashSum,
          TotalFC: next.InvoicePaymentDetail.CashSumFC,
          TotalTransfer: next.InvoicePaymentDetail.TrsfrSum,
          TotalTransferFC: next.InvoicePaymentDetail.TrsfrSumFC
        });
        this.totalDocument = 0;
        this.totalDocument = next.InvoicePaymentDetail.CashSum + next.InvoicePaymentDetail.CashSumFC + next.InvoicePaymentDetail.TrsfrSumFC + next.InvoicePaymentDetail.TrsfrSum;
        this.cards = next.InvoicePaymentDetail.Cards;
        this.cards.forEach(x => {
          const DATE_DUE = new Date(x.FirstDue);
          const DATE_EXPIRATION = new Date(x.CardValid);
          this.totalDocument = this.totalDocument + x.CreditSum;
          x.FirstDue = DATE_DUE;
          x.CardValid = DATE_EXPIRATION;
        });
      }
      else {
        this.alertService.errorAlert(`Error al obtener el detalle de la factura: Error: ${next.errorInfo.Code}, Detalle: ${next.errorInfo.Message}`);
      }
      this.blockUI.stop();
    }, error => {
      console.log(error);
      this.blockUI.stop();
    }, () => { this.blockUI.stop() });
    this.invoiceSelected = status.target.checked;
    this.invList.forEach(inv => {
      if (inv.DocEntry === entry) {
        inv.Selected = true;
      } else {
        inv.Selected = false;

      }
    });

  }
  // envia la informacion para cancelar el pago
  // no recive paramestros
  enviarInfo() {

    if (!this.paymentDetail || !this.invList || !this.invList.some(x => x.Selected)) {
      this.alertService.infoInfoAlert(`Por favor seleccione una factura para poderla cancelar`);
      return;
    }
    this.blockUI.start('Cancelando pago, espere por favor');
    this.paymentDetail.DocNum = this.invoiceNumber;


    if (this.paymentDetail.Cards.length > 0 && this.storageService.getCurrentSessionOffline() !== null && JSON.parse(this.storageService.getCurrentSessionOffline()).access_token !== 'empty_token') { // LA VALIDACION DE SI LA SESSION NO VA CUANDO YA SE IMPLEMENTE EL PIN PAD _TOREVERSE_
      this.pays.cancelPinPadCards(this.paymentDetail).subscribe(next => {
        this.blockUI.stop();
        if (next.result) {
          this.raiseCancelPayment();
        }
        else {
          if (next.errorInfo.Code == -5) { // Signfica que hay el pago con tarjetas se hizo manual
            this.raiseCancelPayment();
          }
          else {
            this.alertService.errorAlert(`Error al cancelar el pago. Motivo: ${next.errorInfo.Message}`);
          }
        }
        console.log('Error', next);
      }, error => {
        this.blockUI.stop();
        this.alertService.errorAlert(`Error al cancelar el pago. Motivo: ${error}`);
        console.log('error detail', error);
      });
    }
    else {
      this.raiseCancelPayment();
    }
  }
  raiseCancelPayment(): void {
    let entry = '';
    let numFact = '';
    let numPago = '';
    this.invList.forEach(inv => {

      if (inv.Selected) {
        entry = inv.DocEntry;
        numFact = inv.DocNum;
        numPago = inv.DocNumPago;
      }
    });
    if (!this.invoiceSelected) {
      this.alertService.infoAlert('Selecccione Factura a Cancelar');
      return;
    }
    const canPay = {
      DocEntry: entry
    };

    this.pays.CancelPayment(canPay).subscribe(callback  => {
      this.blockUI.stop(); // Stop blocking
        this.titlePayment ="Pago cancelado correctamente";
        this.returnedDocNumF = numFact;
        this.returnedDocNumP = numPago;
        (<HTMLButtonElement>document.getElementById('triggerAfterPayModal')).click();
        // this.alertService.successAlertHtml(`Pago Cancelado Correctamente  <br/> Numero de Factura: ${numFact}<br/>  Numero de Pago: ${numPago}`);
        this.getInvList();

    }, (error) => {
      this.blockUI.stop(); // Stop blocking
      let err = error && error.Code ? `Error al cancelar pago, Código: ${error.Code}, Mensaje: ${error.Message}`: '';
      this.alertService.errorAlert(err ? err :`Error al intentar conectar con el servidor, Error: ${error}`);
    });
  }
  // llena los campos de la tabla de items con los campos parametriados
  GetParamsViewList() {
    this.paramsService.getParasmView()
      .subscribe((data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.viewParamTitles = data.Params.filter(param => {
            return param.type === 6;
          });
          this.ChargeParamstoView();
        } else {
          this.alertService.errorAlert('Error al cargar los parámetros de la pagina - ' + data.errorInfo.Message);
        }
      }, error => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert('Se produjo un error al intentar conectar con el servidor ');
      });
  }

  raiseModelDetail(_docEntry: number, _invoiceNumber: number, _payMent: IPayment, status: any): void {
    this.invList.forEach(inv => inv.Selected = false);
    this.globalStatus = status;
    if ((<HTMLInputElement>document.getElementById('' + this.invoiceNumber)) !== null) (<HTMLInputElement>document.getElementById('' + this.invoiceNumber)).checked = false;
    this.blockUI.start('Obteniendo detalle de pago, espere por favor');
    this.pays.getPaymentDetail(_docEntry).subscribe(next => {
      if (next.result) {
        this.paymentDetail = next.InvoicePaymentDetail;
        this.invoiceNumber = _invoiceNumber;
        this.fillDetailPaymentForm();
        this.detailPaymentForm.patchValue({
          InvoiceNumber: _invoiceNumber,
          PaymentNumber: _payMent.DocNumPago,
          Total: next.InvoicePaymentDetail.CashSum,
          TotalFC: next.InvoicePaymentDetail.CashSumFC,
          TotalTransfer: next.InvoicePaymentDetail.TrsfrSum,
          TotalTransferFC: next.InvoicePaymentDetail.TrsfrSumFC
        }
        );
        this.totalDocument = 0;
        this.totalDocument = next.InvoicePaymentDetail.CashSum + next.InvoicePaymentDetail.CashSumFC + next.InvoicePaymentDetail.TrsfrSumFC + next.InvoicePaymentDetail.TrsfrSum;
        this.cards = next.InvoicePaymentDetail.Cards;
        this.cards.forEach(x => {
          const DATE_DUE = new Date(x.FirstDue)
          const DATE_EXPIRATION = new Date(x.CardValid);
          this.totalDocument = this.totalDocument + x.CreditSum;
          x.FirstDue = DATE_DUE;
          x.CardValid = DATE_EXPIRATION;
        });
        (<HTMLButtonElement>document.getElementById('triggerDetailModal')).click();
      }
      else {
        this.alertService.errorAlert(`Error al obtener el detalle de la factura: Error: ${next.errorInfo.Code}, Detalle: ${next.errorInfo.Message}`);
      }
      this.blockUI.stop();
    }, error => {
      console.log(error);
      this.blockUI.stop();
    }, () => { this.blockUI.stop() });
    this.invoiceSelected = status.target.checked;
  }

  setSelectedInvoice(): void {
    console.log('global values ', this.globalStatus);
    this.invList.forEach(x => {
      if (x.DocNum === this.invoiceNumber) {
        if ((<HTMLInputElement>document.getElementById('' + x.DocNumPago)) !== null) {
          this.invList.forEach(inv => inv.Selected = inv.DocNum === this.invoiceNumber);
          this.invoiceSelected = true;
          (<HTMLInputElement>document.getElementById('' + x.DocNumPago)).checked = true;
        }
      }
    });
  }

  // Carga los datos parametrizados en las variables
  ChargeParamstoView() {
    // parametrizacion del titulo
    let obj = this.viewParamTitles.filter(param => {
      return param.Name === 'T_cancelPay';
    });
    this.title = obj[0].Text;
  }

  /**
   * Opens a search modal.
   */
  RiseSearchModalBP():void {
    let modalOption: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'Modal-Xl',
      centered: true
    };

    let modalSearchItems = this.modalService.open(SearchModalComponent, modalOption);
    modalSearchItems.componentInstance.title = 'Busqueda de clientes';
    modalSearchItems.componentInstance.columns = [ 'CardCode','CardName'];
    modalSearchItems.componentInstance.columnsName = ['Código','Nombre'];
    modalSearchItems.componentInstance.SearchData =  this.SearchBP;
    modalSearchItems.componentInstance.selectRecord.subscribe((bp) => {
      this.SelectRecordBp(bp);
    });
  }

  /**
   * Searches for items based on the provided search parameters.
   *
   * @param _data The search parameters.
   * @returns An observable that emits an array of ItemModelSearch objects.
   */
  SearchBP= (_data: ParamsSearch):Observable<IBusinessPartnerModel[]> => {
    return this.bps.GetBussinesPartners(_data.SearchValue,_data.Page,_data.PageRecords).
    pipe(map(result => result.BusinessPartnerFilter));
  }

  /**
   * Selects a record item for further operations.
   *
   * @param item The item to be selected.
   */
  SelectRecordBp(item: IBusinessPartnerModel) {
    if(item!=null) {
      let customer: IBusinessPartnerModel = item;
      if (customer) {
        this.InfoInv.patchValue({ Cliente: customer.FilterField });
      }
    }
  }

}
